export const INIT_FILTER_FIELDS = {
    adviserCode: "", campusId: 0, 
    date: -1,
    student: {
        field: "",
        id: ""
    }
};